var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rb-steps-count"},[_vm._v(" Step "+_vm._s(_vm.currentStep + 1)+" / "+_vm._s(_vm.totalSteps)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }